module.exports = __webpack_public_path__ + "img/user-guide-03-01.d7d8be67.png";